import React from 'react';
import { FormikProps, withFormik } from 'formik';

import { Contact } from '@/types/contact';
import { billingContactSchema } from '@/services/validators/contact';
import { FormContents } from './BillingContactForm/FormContents';

export type OuterProps = {
  contact: Contact;
  isConnecting: boolean;
  onSubmit: (contact: Contact) => void;
};

type Values = Contact;

export const BillingContactForm = withFormik<OuterProps, Values>({
  mapPropsToValues: ({ contact }) => contact,
  validationSchema: billingContactSchema,
  handleSubmit: (values, { props }) => {
    // trimの処理をapi通信側によせたい
    const contact: Contact = {
      id: values.id,
      organizationId: values.organizationId,
      corporationName: values.corporationName.trim(),
      departmentName: values.departmentName.trim(),
      firstName: values.firstName.trim(),
      lastName: values.lastName.trim(),
      kanaFirstName: values.kanaFirstName.trim(),
      kanaLastName: values.kanaLastName.trim(),
      phoneNumber: values.phoneNumber.trim(),
      email: values.email.trim(),
      ccEmail: values.ccEmail?.trim(),
      addressee: values.addressee?.trim(),
    };
    props.onSubmit(contact);
  },
})(
  // enhanced form
  ({
    errors,
    handleSubmit,
    touched,
    values,
    isConnecting,
    setSubmitting,
    resetForm,
    setFieldTouched,
    handleChange,
  }: OuterProps & FormikProps<Values>) => {
    return (
      <FormContents
        errors={errors}
        handleSubmit={handleSubmit}
        touched={touched}
        values={values}
        isConnecting={isConnecting}
        setSubmitting={setSubmitting}
        resetForm={resetForm}
        setFieldTouched={setFieldTouched}
        handleChange={handleChange}
      />
    );
  },
);
